/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/ban-ts-comment */
import { Position3D } from '@deck.gl/core';
import { IconLayer } from '@deck.gl/layers';
import { Marker, ICON_ATLAS, ICON_MAPPING, MarkerData } from '../mapHelpers';
import { getDataBandParams } from '../../../utils/dataBandParams';
import { VarName } from '../../../utils/varNames';
import { getMotionUtlBandParams } from '../../CalendarView/helpers';

const getMotionPins = (markerData: MarkerData[], isUtlData: boolean): IconLayer<Marker> | null => {
  if (!markerData?.length) {
    return null;
  }

  const personMarkers: Marker[] = [];
  markerData.forEach((sensor) => {
    const { id, value, position } = sensor;
    const bandDetail = isUtlData
      ? getMotionUtlBandParams(value)
      : getDataBandParams(VarName.MotionEvent, value);
    let icon = 'circle';
    if (bandDetail && bandDetail.atlasIcon) icon = bandDetail.atlasIcon;

    personMarkers.push({
      id,
      location: 'location',
      name: 'name',
      coordinates: [position.lng, position.lat, position.height ?? 1.25],
      availableData: [],
      icon,
    });
  });

  if (personMarkers.length === 0) {
    return null;
  }

  return new IconLayer({
    id: 'motion-pin-layer',
    data: personMarkers,
    billboard: false, // icon faces up (z) when false
    pickable: false,
    iconAtlas: ICON_ATLAS,
    iconMapping: ICON_MAPPING,
    getIcon: (d) => d.icon ?? 'circle',
    sizeScale: 0.8,
    sizeUnits: 'meters',
    getPosition: (d) => d.coordinates as Position3D,
    getIconColor: [52, 95, 145, 128],
    alphaCutoff: 0.5,
  });
};

export default getMotionPins;
